import React, { Component } from "react";
import PropTypes from "prop-types";
import { injectIntl, defineMessages } from "react-intl";
import { connect } from "react-redux";

import {
  ModalTemplate,
  ReduxFormMaterialTextField,
  ReduxFormMaterialSwitch,
  Button,
} from "components";

import { reduxForm } from "redux-form";
import { targetEmailAsyncValidate } from "libs/validation";
import { Dropdown } from "semantic-ui-react";

import styles from "../../../style/modal.css";
import classNames from "classnames/bind";
const cx = classNames.bind(styles);

class ModalTargetAdd extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { handleChangeTag } = this.props;
    // 모달 새로 열었을 때 태그 값 초기화
    handleChangeTag();
  }

  // 다이얼로그 옵션 리스트(모든 태그 목록 옵션 반환)
  tagOptions = () => {
    const { tagDataByTagNo } = this.props;
    const tagDataArray = [];
    tagDataByTagNo.map((tagItem) => {
      tagDataArray.push({
        key: tagItem.get("tagNo"),
        value: tagItem.get("tagNo"),
        text: tagItem.get("tagName"),
      });
    });

    return tagDataArray;
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const {
      visible,
      isClicked,
      onAddTarget,
      onToggleModal,
      handleChangeTag,
      handleSearchChange,
      handleBlur,
      searchText,
    } = this.props;

    return (
      <ModalTemplate
        closeOnEscape={false}
        closeOnDimmerClick={false}
        className={cx("modal-targetAdd-area", "common-content")}
        visible={visible}
        onToggleModal={onToggleModal}
        header={defineMessages(
          formatMessage({
            id: "ModalTargetAdd_1",
            defaultMessage: "대상자 등록",
          })
        )}
        buttons={
          <div className={cx("inline-block")}>
            <Button
              buttonColor="#bbbbbb"
              onClick={() => {
                onToggleModal("");
              }}
            >
              {defineMessages(
                formatMessage({
                  id: "ModalTargetAdd_2",
                  defaultMessage: "취 소",
                })
              )}
            </Button>
            <Button
              className={cx("brand-button")}
              onClick={onAddTarget}
              disabled={isClicked || !!searchText}
              loading={isClicked}
            >
              {defineMessages(
                formatMessage({
                  id: "ExamTemplateEdit_6",
                  defaultMessage: "등 록",
                })
              )}
            </Button>
          </div>
        }
      >
        <div className={cx("modal-content")}>
          <div className={cx("modalTargetAdd-wrapper", "target")}>
            <div className={cx("wrapper-inner")}>
              <span className={cx("materialTextField-title")}>
                {defineMessages(
                  formatMessage({
                    id: "ModalTargetAdd_3",
                    defaultMessage: "이름*",
                  })
                )}
              </span>
              <ReduxFormMaterialTextField
                className={cx("materialTextfield", "input-area")}
                name="targetName"
                // label={defineMessages(formatMessage({ id: 'ModalTargetAdd_3', defaultMessage: '이름*' }))}
                checkType={101}
                validate={["required", "targetName"]}
              />
              <span className={cx("materialTextField-title")}>
                {defineMessages(
                  formatMessage({
                    id: "ModalTargetAdd_4",
                    defaultMessage: "이메일*",
                  })
                )}
              </span>
              <ReduxFormMaterialTextField
                className={cx("materialTextfield", "input-area")}
                name="targetEmail"
                // label={defineMessages(formatMessage({ id: 'ModalTargetAdd_4', defaultMessage: '이메일*' }))}
                checkType={101}
                validate={["required", "email"]}
              />
              <span className={cx("materialTextField-title")}>
                {defineMessages(
                  formatMessage({
                    id: "ModalTargetAdd_5",
                    defaultMessage: "연락처",
                  })
                )}
              </span>
              {/* 연락처의 정규식은 숫자와 '-'만 가능 */}
              <ReduxFormMaterialTextField
                className={cx("materialTextfield", "input-area")}
                name="targetPhone"
                // label={defineMessages(formatMessage({ id: 'ModalTargetAdd_5', defaultMessage: '연락처' }))}
                checkType={101}
                validate={["userPhone"]}
              />
              <span className={cx("materialTextField-title")}>
                {defineMessages(
                  formatMessage({
                    id: "ModalTargetAdd_6",
                    defaultMessage: "소속",
                  })
                )}
              </span>
              <ReduxFormMaterialTextField
                className={cx("materialTextfield", "input-area")}
                name="targetDivision"
                // label={defineMessages(formatMessage({ id: 'ModalTargetAdd_6', defaultMessage: '소속' }))}
                checkType={101}
                validate={["targetDivision"]}
              />
              <span className={cx("materialTextField-title")}>
                {defineMessages(
                  formatMessage({
                    id: "ModalTargetAdd_7",
                    defaultMessage: "직급",
                  })
                )}
              </span>
              <ReduxFormMaterialTextField
                className={cx("materialTextfield", "input-area")}
                name="targetPosition"
                // label={defineMessages(formatMessage({ id: 'ModalTargetAdd_7', defaultMessage: '직급' }))}
                checkType={101}
                validate={["targetPosition"]}
              />
              <span className={cx("materialTextField-title")}>
                {defineMessages(
                  formatMessage({
                    id: "TargetDetail_3",
                    defaultMessage: "태그",
                  })
                )}
              </span>
              <div className={cx("target-tag-register")}>
                <div className={cx("tagTarget-dropdown-wrapper")}>
                  <Dropdown
                    className={cx("tagTarget-dropdown", "tag-border")}
                    placeholder={defineMessages(
                      formatMessage({
                        id: "TargetDetail_8",
                        defaultMessage: "태그를 입력하세요",
                      })
                    )}
                    name="targetTag"
                    fluid
                    multiple
                    search
                    selection
                    autoFocus
                    options={this.tagOptions()}
                    onChange={handleChangeTag}
                    onSearchChange={handleSearchChange}
                    onBlur={handleBlur}
                  />
                  {searchText && (
                    <div
                      className={cx(
                        "ui pointing basic label pointing-label",
                        "search-error"
                      )}
                    >
                      {defineMessages(
                        formatMessage({
                          id: "ModalTagTargetAdd_4",
                          defaultMessage: "추가할 태그를 선택하세요.",
                        })
                      )}
                    </div>
                  )}
                </div>
              </div>
              <div className={cx("input-area-mt")}>
                <ReduxFormMaterialSwitch
                  className={cx("input-switch")}
                  label={defineMessages(
                    formatMessage({
                      id: "ModalTargetAdd_12",
                      defaultMessage: "기존에 삭제된 대상자 재등록",
                    })
                  )}
                  name="isResurrection"
                  checkType={101}
                />
              </div>
            </div>
          </div>
        </div>
      </ModalTemplate>
    );
  }
}

ModalTargetAdd.propTypes = {
  visible: PropTypes.bool,
  onAddTarget: PropTypes.func,
  onToggleModal: PropTypes.func,
};

export default reduxForm({
  form: "formTargetAdd",
  enableReinitialize: true,
  asyncValidate: targetEmailAsyncValidate,
  asyncBlurFields: ["targetEmail"],
  destroyOnUnmount: false,
  touchOnChange: true, // validation 안내를 적절한 시점에 보이기 위해 반드시 필요함
})(injectIntl(ModalTargetAdd));



// WEBPACK FOOTER //
// ./src/script/components/modal/ModalTargetAdd.js